export default {
  node:{
    rect:{
      type:'rect',
      size:[100,50],
      style:{},
      label:'矩形节点',
      labelCfg:{
        position:'center',
        style:{
          fill:'#4192ff',
          fontSize:13,
        }
      }
    },
    circle:{
      type:'circle',
      size:50,
      style:{},
      label:'圆形节点',
      labelCfg:{
        position:'center',
        offset:0,
        style:{
          fill:'#4192ff',
          fontSize:13,
        }
      }
    },
    diamond:{
      type:'diamond',
      size:[100,50],
      style:{},
      label:'菱形节点',
      labelCfg:{
        position:'center',
        style:{
          fill:'#4192ff',
          fontSize:13,
        }
      }
    },
    ellipse:{
      type:'ellipse',
      size:[100,50],
      style:{},
      label:'椭圆节点',
      labelCfg:{
        position:'center',
        style:{
          fill:'#4192ff',
          fontSize:13,
        }
      }
    },
    star:{
      type:'star',
      size:50,
      style:{},
      label:'星形节点',
      labelCfg:{
        position:'center',
        style:{
          fill:'#4192ff',
          fontSize:13,
        }
      }
    },
    triangle:{
      type:'triangle',
      size: 100,
      style:{},
      label:'三角形节点',
      labelCfg:{
        position:'center',
        style:{
          fill:'#4192ff',
          fontSize:13,
        }
      }
    },
    image:{
      type:'image',
      img: '/file/imgPool/20220124105201jimg.jpg',
      size: [100,100],
      style:{},
      label:'图片节点',
      labelCfg:{
        position:'bottom',
        style:{
          fill:'#4192ff',
          fontSize:13,
        }
      }
    }
  },
  edge:{
    line: {
      type:'line',
      style: {
        stroke: '#32a2ff',
        lineWidth: 1,
        lineDash: [0],
        endArrow: false
      },
      label:'',
      labelCfg:{
        position:'middle',
        style:{
          fill:'#32a2ff',
          fontSize: 13
        }
      }
    },
    polyline:{
      type:'polyline',
      style: {
        stroke: '#ff32cf',
        lineWidth: 1,
        lineDash: [0],
        endArrow: false
      },
      label:'',
      labelCfg:{
        position:'middle',
        style:{
          fill:'#32a2ff',
          fontSize: 13
        }
      }
    },
    quadratic:{
      type:'quadratic',
      style: {
        stroke: '#ff3239',
        lineWidth: 2,
        lineDash: [0],
        endArrow: false
      },
      label:'',
      labelCfg:{
        position:'middle',
        style:{
          fill:'#32a2ff',
          fontSize: 13
        }
      }
    },
    cubic:{
      type:'cubic',
      style: {
        stroke: '#ffcf32',
        lineWidth: 1,
        lineDash: [0],
        endArrow: false
      },
      label:'',
      labelCfg:{
        position:'middle',
        style:{
          fill:'#32a2ff',
          fontSize: 13
        }
      }
    },
    loop:{
      type:'loop',
      style: {
        stroke: '#ffcf32',
        lineWidth: 1,
        lineDash: [0],
        endArrow: false
      },
      label:'自环',
      labelCfg:{
        position:'middle',
        style:{
          fill:'#32a2ff',
          fontSize: 13
        }
      }
    }
  }
}